import type { NavigateFunction } from "react-router-dom";

let navigate: NavigateFunction | null = null;

export function bindNavigate(fn: NavigateFunction) {
  navigate = fn;
}

export function appGo(to: string) {
  navigate?.(to);
}
